import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

import styles from './Separator.module.scss';

export interface SeparatorProps extends HTMLAttributes<HTMLHRElement> {}

/**
 * Horizontal rule that visually divides adjacent content blocks.
 * Used in generative UI responses and anywhere a soft divider is
 * needed between sections.
 */
export const Separator = ({ className, ...rest }: SeparatorProps) => (
  <hr
    data-testid="separator"
    className={clsx(styles.root, className)}
    {...rest}
  />
);
